var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111.229,
    height: 111.186,
    viewBox: "0 0 96.229 109.186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.201,
    x2: 2.01,
    y2: 1.327,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55a4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55a4ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_62504",
    x: 0,
    y: 0,
    width: 111.229,
    height: 111.186,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_62505",
    x: 4.239,
    y: 34.965,
    width: 72.067,
    height: 72.056,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-rocket",
    "data-name": "Icon ionic-ios-rocket",
    transform: "translate(21.634 21.628)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.63, -21.63)",
    filter: "url(#Path_62504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62504-2",
    "data-name": "Path 62504",
    d: "M54.325,4.067a.544.544,0,0,0-.406-.419c-6.7-1.637-22.172,4.2-30.556,12.582a36.239,36.239,0,0,0-4.075,4.814,15.163,15.163,0,0,0-7.374.923C5.7,24.7,3.887,31.84,3.382,34.906a1.1,1.1,0,0,0,1.206,1.28l9.984-1.1a22.2,22.2,0,0,0,.135,2.253,2.234,2.234,0,0,0,.652,1.367l3.866,3.866a2.234,2.234,0,0,0,1.367.652,22.153,22.153,0,0,0,2.241.135l-1.1,9.972a1.1,1.1,0,0,0,1.28,1.206c3.065-.492,10.218-2.3,12.939-8.519a15.232,15.232,0,0,0,.936-7.35A36.3,36.3,0,0,0,41.719,34.6C50.139,26.227,55.938,11.1,54.325,4.067ZM34.234,23.752a5.258,5.258,0,1,1,7.436,0A5.253,5.253,0,0,1,34.234,23.752Z",
    transform: "translate(21.63 21.63)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.63, -21.63)",
    filter: "url(#Path_62505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62505-2",
    "data-name": "Path 62505",
    d: "M17.138,29.316h0A4.67,4.67,0,0,1,14.7,30.3a3.314,3.314,0,0,1-3.816-3.816,4.578,4.578,0,0,1,.973-2.425l.012-.012a.412.412,0,0,0-.345-.7,5.659,5.659,0,0,0-3.312,1.613C6,27.174,5.787,35.4,5.787,35.4s8.236-.209,10.452-2.425a5.622,5.622,0,0,0,1.613-3.312A.421.421,0,0,0,17.138,29.316Z",
    transform: "translate(23.45 36.62)",
    fill: "url(#linear-gradient)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.6b63028beec9c5f74c1b1bb5c0839a8e.svg";
export { ForwardRef as ReactComponent };